import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { DeadlineService } from '../../../../services/deadline.service';

//import services
import { NotificationService } from '../../../../services/notification.service';

declare var $: any;

@Component({
  selector: 'app-notification_create',
  templateUrl: './notification_create.component.html',
  styleUrls: ['./notification_create.component.css']
})
export class NotificationCreateComponent implements OnInit {
  @Input() ID: string;
  @Input() langs;
  @Input() redirect: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  modalTitle: string;
  

  lang: any;
  generalLang: any;
  record: any;
  mode: string;

  imageLink: any;
  data: any;
  details: any;
  redirect1: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  constructor(
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

        //fetch data
    // this.details = this.route.snapshot.data['data'];
    
    // console.log(this.langs); 

    
    this.getData();
    this.FormBuild();
    this.config();
    this.fileDesign();
  }

  config(): void {
        


  }

  FormBuild(): void {
    
    this.createForm = this.formBuilder.group({
      type: ['', [Validators.required]],
      date: [''],
      subject: [''],
      description: [''],
      notes: [''],
      id: '',
      timetable_link: this.formBuilder.array([this.newAttachment()]),
      timetable_link_uploaded: this.formBuilder.array([]),
      action: 'update',
    });



    setTimeout(() => this.fileDesign(), 10);

    this.timetable_link().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });
    

  }

  FormBuildUpdate(): void {
    // this.emptyEmail();
    this.createForm.patchValue({
      type: this.record.cat_type,
      date: this.record.noti_date,
      subject: this.record.subject,
      description: this.record.disp,
      notes: this.record.notes,
      id: this.record.id
    });
    
    // if(this.record.timetable_link) {
    //   for (const image of images) {
    //     this.timetable_link_uploaded().push(new FormControl(image.split('/').pop()));
    //   }
    // }
        
    setTimeout(() => this.fileDesign(), 10);
  }

  send_email() : FormArray {
    return this.createForm.get("send_email") as FormArray
  }
   
  newEmail(data = ''): FormControl {
    return new FormControl(data, Validators.email);
  }
   
  addEmail() {
    this.send_email().push(this.newEmail());
  }
   
  removeEmail(i:number) {
    this.send_email().removeAt(i);
  }

  emptyEmail() {
    while (this.send_email().controls.length > 0) {
      this.send_email().removeAt(0);
    }
  }

  timetable_link(): FormArray {
    return this.createForm.get('timetable_link') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      // link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
      link: ['']
    });
  }

  addAttachment(): void {
    this.timetable_link().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.timetable_link().removeAt(i);
  }

  timetable_link_uploaded(): FormArray {
    return this.createForm.get('timetable_link_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.timetable_link_uploaded().removeAt(i);
  }
  
  public selectAttachment(event: any, index) {

    this.createForm.value.timetable_link[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
          this.createForm.value.timetable_link[index].link = {'name': file.name, 'image': reader.result};
      };
    }
    
  }

  fileDesign(){
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
      'text': this.langs.choose_file
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }

  onSubmit() {

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;
    
    this.notificationService.update(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.data);
          this.bsModalRef.hide();
          
          if (this.redirect1 == "") {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.Notification_List]);
              });
          }
          else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.Notification_List]);
          });
          }
          
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

  getData() {

    // console.log(this.langs); return false;

    if (this.ID) {
      // alert(this.ID); return false;
      this.notificationService.edit(this.ID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }

          this.lang = this.langs;
          this.record = res.data.course;

          // console.log(this.record);

          this.FormBuildUpdate();
        }
      );

      this.typeConfig = [
        { value: 'COMMUNICATION', text: 'COMMUNICATION' },
        { value: 'CONSULTATION', text: 'CONSULTATION' },
        { value: 'OTHER', text: 'OTHER' },
      ];

      
      this.generalLang = this.langs;
      this.redirect1 = this.redirect;

      this.mode = 'Edit';
      this.modalTitle = this.generalLang.editNotification;
    }
    else {

      this.generalLang = this.langs;
      this.redirect1 = '';

      this.typeConfig = [
        { value: 'COMMUNICATION', text: 'COMMUNICATION' },
        { value: 'CONSULTATION', text: 'CONSULTATION' },
        { value: 'OTHER', text: 'OTHER' },
      ];

      this.mode = 'Create';
      this.modalTitle = this.generalLang.notificationDetails;
    }

    this.createFormErrorMsg = {
      'type': [{ type: 'required', message: this.generalLang.requiredField }],
    }

  }

}
